function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".green{fill:#29ed87;}.black{fill:#2e293a;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-50.222 -0.444)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "green",
  cx: 21,
  cy: 21,
  r: 21,
  transform: "translate(50.222 0.444)"
}), /*#__PURE__*/React.createElement("path", {
  className: "black",
  d: "M14.222,1.369a5.84,5.84,0,0,1-1.676.46A2.931,2.931,0,0,0,13.83.215a5.839,5.839,0,0,1-1.854.708A2.919,2.919,0,0,0,7,3.583,8.288,8.288,0,0,1,.991.535a2.922,2.922,0,0,0,.9,3.9,2.913,2.913,0,0,1-1.32-.365,2.921,2.921,0,0,0,2.341,2.9,2.924,2.924,0,0,1-1.318.05A2.922,2.922,0,0,0,4.322,9.038,5.872,5.872,0,0,1,0,10.248a8.253,8.253,0,0,0,4.472,1.311,8.252,8.252,0,0,0,8.294-8.68,5.882,5.882,0,0,0,1.457-1.51Z",
  transform: "translate(64 16)"
}));
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.3f3b19523c511ef26324756040f0b920.svg";
export { ForwardRef as ReactComponent };